import Vue from 'vue'
import axiosOrign from 'axios'
import {
  axios
} from '@/utils/request'

const state = {
  rankData: {},
  analysisData: {},
  scheduleId: '',
  classesId: '',
  planclassesId: '',
  stuId: '',
  scheduleInfo: {},
  courseId: '',
  courseName: '',
  courseTime: '',
  examId: null,
  questionId: null,
  explainId: null,
  examInfo: {},
  tabInfo: {},
  doExerId: '',
  doExerTime: 0,
  titleTime: 0,
  examIdList: [],
  countDown: 0,
  userTime: 0,
  finish: false,
  isVoluntarilySave: true,
  testPaper: {},
  doTestPaper: {},
  isChange: false
}
const mutations = {
  update(state, payload) {
    for (const key in payload) {
      Vue.set(state, key, payload[key])
    }
  },
  setCourseId: (state, payload) => {
    state.courseId = payload
  },
  setScheduleInfo: (state, payload) => {
    state.scheduleInfo = payload
  },
  setCourseName: (state, payload) => {
    state.courseName = payload
  },
  setCourseTime: (state, payload) => {
    state.courseTime = payload
  },
  setExamId: (state, payload) => {
    console.error('设置examId' + payload)
    state.examId = payload
  },
  setTabInfo: (state, payload) => {
    console.error('设置tabInfo' + payload)
    state.tabInfo = payload
  },
  setExamInfo: (state, payload) => {
    state.examInfo = payload
  },
  setExplainId: (state, payload) => {
    state.explainId = payload
  },
  setQuestionId: (state, payload) => {
    state.questionId = payload
  },
  setPlanclassesId: (state, payload) => {
    state.planclassesId = payload
  }
}

const getters = {
  courseId: state => {
    return state.courseId
  },
  courseName: state => {
    return state.courseName
  },
  courseTime: state => {
    return state.courseTime
  },
  planclassesId: state => {
    return state.planclassesId
  }
}

const actions = {
  // 获取试卷内容
  async getExamsContent({ commit }, payload) {
    axiosOrign({
      method: 'get',
      url: payload.examUrl,
      timeout: 1000 * 30,
      headers: payload.headers ? payload.headers : {}
    }).then((res) => {
      if (payload.callback) {
        commit('setExamInfo', res.data)
        commit('examId', res.examId)
        payload.callback(res.data, null)
      }
    })
      .catch((err) => {
        if (payload.callback) {
          payload.callback(null, err)
        }
      })
  },
  // 切换答案解析tab
  async switchAnalysisTab({ commit }, payload) {
    const postData = {
      openAnalysis: payload.openAnalysis,
      currentQuestionId: payload.currentQuestionId,
      examId: payload.examId,
      scheduleId: payload.scheduleId,
      type: '4',
    }
    await axios.post('b/classes/web/socket/schedule/switchAnalysisTab', postData).then((res) => {
      if (payload.callback) {
        payload.callback(res, null)
      }
    }).catch((err) => {
      if (payload.callback) {
        payload.callback(null, err)
      }
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
